import { useSelector } from "react-redux";
import { AppState } from "../../../core/app/AppReducer";
import KokiriSword from "../../../core/assets/oot/gshd/kokiri-sword_32x32.png";
import Item from "../../../core/items/Item";
import OotItem from "./OotItem";
import { ItemLightDto } from "../../../core/items/ItemDataTypes";
import { isNil } from "lodash";
import { SimpleItemProps } from "./SimpleItemProps";
import StaticItem from "../../../core/items/StaticItem";

interface ItemProps {
    items?: Array<ItemLightDto>
    onChange?: (v: ItemLightDto) => void,
    noRedux?: true
}

const id = "OoT_KokiriSword";
const KokiriSwordItem = (props: ItemProps) => {

  

    let reduce = useSelector((state: AppState) => state.ui.ootr.main.useItemTrackerReduce)
    let shuffle = useSelector((state: AppState) => state.ui.ootr.main.kokiriSwordShuffle)

    if (reduce && !shuffle && !props.noRedux)
        return null;

    return <OotItem id={id} items={props.items}>
        {({ updateOotItem, item }) => {
            return <Item id={id} image={KokiriSword} title="Kokiri Sword" 
                            updateItem={(i) => {
                                                if(!props.noRedux)
                                                    updateOotItem(i); 
                                                if(!isNil(props.onChange))
                                                    props.onChange(i)
                                        }} 
                            item={item} isMajor
            />
        }}</OotItem>
}

export default KokiriSwordItem;

export const SimpleKokiriSwordItem  = (props: SimpleItemProps) => {


    return <StaticItem
        image={KokiriSword}
        onClick={props.onClick}
        name={id}
    />

}


export interface DbKokiriSwordItemProps {
    items?: ItemLightDto[] | undefined
    update?: (v:ItemLightDto) => void
}

export const DbKokiriSwordItem = (props: DbKokiriSwordItemProps) => {

    let item = props.items?.filter(x => x.id === id)?.[0] ?? DefaultKokiriSwordItem;

    return <Item
        item={item}
        updateItem={props.update}
        image={KokiriSword}
        id={"Kokiri Sword"}
        title="Kokiri Sword"
        isObtained={item.isObtained}
    />


}

const DefaultKokiriSwordItem : ItemLightDto = {
    img: KokiriSword,
    id: id,
    title: "Kokiri Sword",
    childItem: undefined,
    childItemName: undefined,
    isObtained: false,
    isChecked: false,
    state: 0
}